export const GET_RESET_OPTIONS = 'sys_admin/GET_RESET_OPTIONS';
export const GET_RESET_OPTIONS_RESULTS = 'sys_admin/GET_RESET_OPTIONS_RESULTS';

export function getResetOptions(payload) {
  return { type: GET_RESET_OPTIONS, payload };
}
